import React, { useMemo } from 'react'
import { Row } from 'antd'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import {
  AiHighlightDecoratedComponent,
  ReadMore,
  RichTextHighlightingInput,
} from '../../../common/components/sections'
import { handleAiHighlightStrategy } from '../../../common/helpers'

import { menuTitlePropType } from '../../../menu-title/prop-types'
import { formatDishMenuTitleOriginFieldPrefix } from '../../utils'

const DishMenuTitleCell = ({ menuTitles, highlights }) => {
  const detailComponent = useMemo(
    () =>
      map(menuTitles, (menuTitle, index) => (
        <Row key={menuTitle.id}>
          <strong style={{ display: 'flex' }}>
            {index + 1}.
            <RichTextHighlightingInput
              value={menuTitle.styledTitle || menuTitle.title}
              highlightStrategy={handleAiHighlightStrategy}
              highlights={
                highlights[
                  formatDishMenuTitleOriginFieldPrefix(
                    'menuTitleName',
                    menuTitle.id,
                  )
                ]
              }
              decoratorComponent={AiHighlightDecoratedComponent}
              isReadOnly
            />
          </strong>
        </Row>
      )),

    [highlights, menuTitles],
  )

  return <ReadMore maxHeight={170} component={detailComponent} />
}

DishMenuTitleCell.propTypes = {
  menuTitles: PropTypes.arrayOf(menuTitlePropType).isRequired,
  highlights: PropTypes.object,
}

DishMenuTitleCell.defaultProps = {
  highlights: {},
}

export default DishMenuTitleCell
